import * as vuex from 'vuex-class';

export const namespace = 'editorView';

export const EditorView = vuex.namespace(namespace);

export enum EditorViewAction {
  UpdateInputValue = 'updateInputValue',
}
